import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

export const defaultActiveStyle = {
	fontWeight: 'bold',
}

class TabLink extends Component {

	render() {
		return (
			<div
				className={classNames(this.props.className,
					{
						'tab-link': true,
						[this.props.activeClass]: this.props.isActive,
					})}
				onClick={this.props.handleSelect.bind(this, this.props.to, this.props.namespace)}
			>
				{this.props.children}
			</div>
		)
	}
}

TabLink.propTypes = {
	to: PropTypes.string.isRequired,
	handleSelect: PropTypes.func,
	isActive: PropTypes.bool,
	namespace: PropTypes.string,
	activeStyle: PropTypes.object,
	firstLink: PropTypes.bool,
	style: PropTypes.object,
	children: PropTypes.node,
	className: PropTypes.string,
	activeClass: PropTypes.string,
}

export default TabLink
